import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth/interceptor/auth.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { HeaderComponent } from './header/header.component';
import { AuthGuard } from './auth.guard';
import { AlreadyGuard } from './already.guard';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ErrorInterceptor } from './auth/interceptor/error.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserData } from './auth/userData';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideMenuContentComponent } from './side-menu-content/side-menu-content.component';
import { MatListModule } from '@angular/material/list';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@NgModule({
    declarations: [AppComponent, HeaderComponent, SideMenuContentComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        AuthModule,
        NgSelectModule,
        FormsModule,
        ReactiveFormsModule,
        IonicStorageModule.forRoot({
            name: 'digimaker',
            storeName: 'programming',
            driverOrder: [Drivers.LocalStorage, Drivers.IndexedDB],
        }),
        BrowserAnimationsModule,
        MatSidenavModule,
        MatListModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production, //!isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
    providers: [
        [CookieService],
        AuthGuard,
        AlreadyGuard,
        UserData,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        DatePipe,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
